import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getPeriods } from "../../assets/js/api";
import { getCurrentLanguage } from "../../assets/js/functions";
import Menu from "../../components/Partials/Menu";
import logoExpo from "../../assets/img/logo-expo.svg";
import logoExpoEus from "../../assets/img/logo-expo-euskera.svg";
import Langs from "../../components/Partials/Langs";

const Header = () => {
  const [periods, setPeriods] = useState(null);
  const [logo, setLogo] = useState(null);


  useEffect(() => {
    getPeriods().then((periods) => {
      setPeriods(periods);
    });

    const lang = getCurrentLanguage();
    if (lang == "es") {
      setLogo(logoExpo);
    } else if (lang == "eu") {
      setLogo(logoExpoEus);
    }

  }, []);


  return (
    <header>
      <a href="#main-nav" className="skip-link">
        Menú principal
      </a>
      <a href="#main" className="skip-link">
        Contenido principal
      </a>
      <div className="is-flex is-align-items-center gap-7 py-5 px-6">
        {periods?
        <Menu periods={periods} />
        :''}
        <h1 aria-label="Símbolos de un tiempo" className="site-title">
          <Link to={"/"}>
            <img
              src={logo}
              alt=""
              width="169"
              height="60"
              className="is-hidden-mobile"
            />
          </Link>
        </h1>

        <Langs></Langs>
      </div>
    </header>
  );
};

export default Header;
